import { useMemo } from 'react';

import { useGetDispenseAssetsQuery } from '@/store/api/services/restocking/restocking';

export const useDispenseAssets = () => {
  const {
    data: { data: assetsData } = {},
  } = useGetDispenseAssetsQuery();

  const { billsMap } = useMemo(() => {
    const billsMap: Record<string, string[]> = {};
    for (const asset of assetsData ?? [])
      for (const bill of asset.bills ?? [])
        billsMap[bill.id!] = [asset.name ?? '', String(bill.denomination ?? '')];
    return { billsMap };
  }, [assetsData]);

  return { billsMap, assets: assetsData };
};
